import React, { RefObject, useEffect } from 'react';

import { updateTransform } from './helpers';
import  {
    ParallaxContext,
    TAddLayer,
    TParallaxLayer,
} from './ParallaxContext';

type TParallaxProps = {
    children: React.ReactNode,
    root: RefObject<HTMLElement>,
}

const ParallaxScoped = ({
    children,
    root,
}: TParallaxProps) => {
    const layers: TParallaxLayer[] = [];

    const addLayer: TAddLayer = layer => {
        layers.push(layer);
    };

    const updateStyles = () => {
        const container = root.current;

        if (!container) {
            return;
        }

        for (const layer of layers) {
            const {
                element,
                $translateOffset,
                $translateOffsetStart,
                $perspective,
            } = layer;

            if (!element) {
                continue;
            }

            const { top } = element.getBoundingClientRect();
            const visible = window.innerHeight > top;

            if (!visible) {
                continue;
            }

            const { scrollTop } = container;

            element.style.transform = updateTransform({
                translateOffset: $translateOffset,
                translateOffsetStart: $translateOffsetStart,
                perspective: $perspective,
                offset: element.offsetTop - scrollTop,
            });
        }
    };

    useEffect(() => {
        const container = root.current;

        if (!container) {
            return;
        }

        const onScroll = () => {
            window.requestAnimationFrame(updateStyles);
        };

        container.addEventListener('scroll', onScroll, false);

        return () => {
            container.removeEventListener('scroll', onScroll, false);
        };
    }, [root]);

    return (
        <ParallaxContext.Provider value={{ addLayer }}>
            {children}
        </ParallaxContext.Provider>
    );
};

export default ParallaxScoped;
